import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';

Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: 'https://1d81da6fe3624b32942357b3a25b9c52@sentry.io/1376237',
});

class ErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({ error });
        Sentry.withScope((scope) => {
            Object.keys(errorInfo).forEach((key) => {
                scope.setExtra(key, errorInfo[key]);
            });
            Sentry.captureException(error);
        });
    }

    render() {
        const { error } = this.state;
        const { children } = this.props;

        if (error) {
            // render fallback UI
            return (
              <div>
                  <h1>Ocorreu um erro interno.</h1>
                  <h2>Nossa equipe já foi notificada.</h2>
              </div>
            );
        }
        // when there's not an error, render children untouched
        return children;
    }

}

export default ErrorBoundary;
